import { computed, readonly } from 'vue'

export const useInternshipAdditionalConditions = (businessTypesStore, monthsStore, holdDaysStore, isOnlineStore, isFacingStore, featuresStore, holdAsNeededStore, workContentsStore) => {
  // 選択された詳細条件の数
  const size = computed(() => {
    // isOnline,isFacing,holdAsNeededは未選択のときnullが入るためfilterで除去している
    return [
      businessTypesStore.businessTypes.value,
      monthsStore.months.value,
      holdDaysStore.holdDays.value,
      isOnlineStore.isOnline.value,
      isFacingStore.isFacing.value,
      featuresStore.features.value,
      holdAsNeededStore.holdAsNeeded.value,
      workContentsStore.workContents.value,
    ].flat().filter(Boolean).length
  })
  // 詳細条件が選択されているか?
  const isActive = computed(() => size.value > 0)
  // 開催日数が選択されているか?
  const isActiveHoldDays = computed(() => holdDaysStore.holdDays.value.length > 0)
  // 開催形式が選択されているか?
  // isOnline,isFacingは未選択のときnullが入るためfilterで除去している
  const isActiveRegions = computed(() => [isOnlineStore.isOnline.value, isFacingStore.isFacing.value].flat().filter(Boolean).length > 0)
  // 特徴が選択されているか?
  // holdAsNeededは未選択のときnullが入るためfilterで除去している
  const isActiveFeatures = computed(() => [featuresStore.features.value, holdAsNeededStore.holdAsNeeded.value].flat().filter(Boolean).length > 0)

  const reset = () => {
    businessTypesStore.reset()
    monthsStore.reset()
    holdDaysStore.reset()
    isOnlineStore.reset()
    isFacingStore.reset()
    featuresStore.reset()
    holdAsNeededStore.reset()
    workContentsStore.reset()
  }

  const clear = () => {
    businessTypesStore.clear()
    monthsStore.clear()
    holdDaysStore.clear()
    isOnlineStore.clear()
    isFacingStore.clear()
    featuresStore.clear()
    holdAsNeededStore.clear()
    workContentsStore.clear()
  }

  return {
    size: readonly(size),
    isActive: readonly(isActive),
    isActiveHoldDays: readonly(isActiveHoldDays),
    isActiveRegions: readonly(isActiveRegions),
    isActiveFeatures: readonly(isActiveFeatures),
    reset,
    clear
   }
}